import Upload from './src';

/* istanbul ignore next */
Upload.install = function(Vue) {
  Vue.component(Upload.name, Upload);
};

export default Upload;



// WEBPACK FOOTER //
// ./src/components/upload/index.js